import React from 'react';
import { Shield, Server, Lock, FileCheck, AlertCircle } from 'lucide-react';

// TSC Category icons
const TSC_ICONS = {
  'CC': Shield,
  'Security': Lock,
  'Availability': Server,
  'Processing Integrity': FileCheck,
  'Confidentiality': Lock,
  'Privacy': Shield,
};

const TSCCategoryProgress = ({ data = {} }) => {
  const categories = Object.entries(data).sort(([a], [b]) => a.localeCompare(b));

  if (categories.length === 0) {
    return (
      <div className="bg-white rounded-lg border border-gray-200 p-6">
        <h3 className="text-lg font-semibold text-gray-900 mb-4">
          TSC Category Progress
        </h3>
        <div className="text-center py-8 text-gray-500">
          <AlertCircle className="w-12 h-12 mx-auto mb-3 text-gray-400" />
          <p>No TSC category data available</p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">
        TSC Category Progress
      </h3>

      <div className="space-y-4">
        {categories.map(([category, categoryData]) => {
          const progress = categoryData.progress_percentage || 0;
          const completed = categoryData.completed_tasks || 0;
          const total = categoryData.total_tasks || 0;
          const Icon = TSC_ICONS[category] || Shield;

          return (
            <div key={category} className="p-4 bg-gray-50 rounded-lg border border-gray-100">
              <div className="flex items-center justify-between mb-3">
                <div className="flex items-center gap-2">
                  <div className="w-8 h-8 bg-teal-100 rounded-lg flex items-center justify-center">
                    <Icon className="w-4 h-4 text-teal-600" />
                  </div>
                  <span className="text-sm font-semibold text-gray-900">{category}</span>
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-xs text-gray-500">
                    {completed} of {total} controls
                  </span>
                  <span className={`text-sm font-bold ${
                    progress >= 100
                      ? 'text-green-600'
                      : progress >= 75
                        ? 'text-teal-600'
                        : progress >= 50
                          ? 'text-amber-600'
                          : 'text-gray-600'
                  }`}>
                    {Math.round(progress)}%
                  </span>
                </div>
              </div>

              {/* Progress Bar */}
              <div className="w-full bg-gray-200 rounded-full h-3">
                <div
                  className={`h-3 rounded-full transition-all duration-500 ${
                    progress >= 100
                      ? 'bg-green-500'
                      : progress >= 75
                        ? 'bg-teal-500'
                        : progress >= 50
                          ? 'bg-amber-500'
                          : 'bg-red-500'
                  }`}
                  style={{ width: `${Math.min(progress, 100)}%` }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default TSCCategoryProgress;
